const locale = {
  placeholder: 'Vybrať čas',
}

export default locale



// WEBPACK FOOTER //
// ./components/time-picker/locale/sk_SK.js